import CubeDEXMetrics from "./component";

export default CubeDEXMetrics;
